<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card tile class="help-dialog-fullscreen">
      <v-toolbar flat dark color="rgba(24, 24, 24, 0.6)" style="backdrop-filter: blur(12px); position: fixed; top: 0; width: 100%; z-index: 10">
        <v-toolbar-title class="font-weight-bold">Workout Guide</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon large @click="$emit('update:dialog', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div class="main-content">
        <v-sheet dark color="transparent" class="pa-4 pt-2">
          <v-slide-group v-model="tab" mandatory center-active>
            <v-slide-item v-for="(item, index) in tabs" :key="index" v-slot="{ active, toggle }">
              <v-btn class="mx-2 nav-pill" :input-value="active" active-class="primary--text font-weight-bold" depressed rounded @click="toggle">
                <v-icon left>{{ item.icon }}</v-icon>
                {{ item.name }}
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>

        <v-carousel v-model="tab" :show-arrows="false" hide-delimiters height="calc(100vh - 100px)">
          <v-carousel-item v-for="(item, index) in tabs" :key="index">
            <v-sheet color="transparent" height="100%" class="overflow-y-auto">
              <v-container fluid class="pa-4">
                <feature-card
                  v-for="feature in item.features"
                  :key="feature.title"
                  :icon="feature.icon"
                  :color="feature.color"
                  :title="feature.title"
                  :description="feature.description" />
              </v-container>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import FeatureCard from "./FeatureCard.vue"

export default {
  name: "HelpDialog",
  components: {
    FeatureCard,
  },
  props: {
    dialog: { type: Boolean, required: true },
  },
  data() {
    return {
      tab: 0, // Startet auf dem ersten Tab
      tabs: [
        {
          name: "Anpassen",
          icon: "mdi-tune-variant",
          features: [
            {
              icon: "mdi-plus-box-multiple",
              color: "green",
              title: "Übung Hinzufügen",
              description:
                "Tippe auf das Plus-Icon (+) oben rechts in der Kopfzeile, um jederzeit eine zusätzliche Übung zu deinem laufenden Training hinzuzufügen.",
            },
            {
              icon: "mdi-swap-horizontal-bold",
              color: "orange",
              title: "Übung Tauschen",
              description:
                "In der Detailansicht einer Übung kannst du über das Tauschen-Icon oben rechts die aktuelle Übung spontan durch eine andere für diese Session ersetzen.",
            },
            {
              icon: "mdi-content-save-edit",
              color: "primary",
              title: "Änderungen Speichern",
              description:
                "Am Ende deines Workouts erscheint ein Dialog. Hier entscheidest du mit Checkboxen, welche der hinzugefügten oder getauschten Übungen permanent in deinem Plan gespeichert werden sollen.",
            },
          ],
        },
        {
          name: "Feedback",
          icon: "mdi-comment-quote-outline",
          features: [
            {
              icon: "mdi-emoticon-happy-outline",
              color: "purple",
              title: "Sätze Bewerten",
              description:
                "Bewerte die Schwierigkeit jedes Satzes mit den Smileys. Das ist das wichtigste Werkzeug, um deinen Plan intelligent anzupassen und Fortschritte zu erzielen.",
            },
            {
              icon: "mdi-robot-happy",
              color: "light-blue",
              title: "Automatische Gewichtsvorschläge",
              description:
                "War ein Satz 'Zu Leicht' oder 'Zu Schwer', schlägt dir die App automatisch ein passenderes Gewicht für dein NÄCHSTES Training vor. Du kannst diesen Vorschlag direkt annehmen.",
            },
            {
              icon: "mdi-swap-vertical-bold",
              color: "teal",
              title: "Abweichungen vom Plan",
              description:
                "Dieses Icon erscheint in der Satz-Übersicht, wenn du ein anderes Gewicht als geplant verwendet hast. Es zeigt dir, ob du dich gesteigert (grün) oder das Gewicht reduziert (orange) hast.",
            },
          ],
        },
        {
          name: "Analyse",
          icon: "mdi-chart-line",
          features: [
            {
              icon: "mdi-history",
              color: "blue-grey",
              title: "Live-Trainingsverlauf",
              description:
                "In der Satz-Ansicht kannst du mit den Pfeilen über der Tabelle durch deine letzten Trainingseinheiten für genau diese Übung blättern und deine Leistung vergleichen.",
            },
            {
              icon: "mdi-help-circle-outline",
              color: "grey",
              title: "Feedback Nachtragen",
              description:
                "Eine Bewertung vergessen? Kein Problem. Klicke einfach auf das Fragezeichen-Icon in der Satzliste, um dein Feedback auch später noch abzugeben.",
            },
            {
              icon: "mdi-trophy-award",
              color: "amber",
              title: "Persönliche Rekorde",
              description:
                "Die App erkennt automatisch, wenn du in einer Übung ein neues Maximalgewicht oder ein höheres Satzvolumen erreicht hast und feiert deine neuen persönlichen Rekorde (PRs) auf der Abschluss-Seite.",
            },
          ],
        },
      ],
    }
  },
}
</script>

<style scoped>
.help-dialog-fullscreen {
  background: #181818;
}

.main-content {
  padding-top: 64px; /* Platz für die fixe Toolbar */
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.nav-pill {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: rgba(255, 255, 255, 0.6) !important;
  transition: all 0.3s ease-in-out;
}

.nav-pill.v-btn--active {
  background-color: #ffffff !important;
  transform: scale(1.1);
}

/* Wichtig, damit der Container des Karussells flexibel ist */
.v-carousel {
  flex-grow: 1;
}
</style>
